import { useState } from 'react';
import { connect } from 'react-redux';
import { bindActionCreators } from '@reduxjs/toolkit';
import { Helmet } from 'react-helmet';
import moment from 'moment-timezone';
import { withRouter } from 'react-router';
import I18njs from 'i18n-js';

import LoginForm from './Login';
import MfaForm from './Mfa';

import * as UserActions from '../../redux/User/actions';
import FallbackMfaForm from './FallbackMfa';

export const Login = ({ error, history, loading, login, sendFallbackMfa }) => {
  const [code, setCode] = useState('');
  const [company, setCompany] = useState('');
  const [fallbackToken, setFallbackToken] = useState('');
  const [username, setUsername] = useState('');
  const [password, setPassword] = useState('');
  const [showMfa, setShowMfa] = useState(false);
  const [showFallbackMfa, setShowFallbackMfa] = useState(false);

  const handleSubmit = (e) => {
    e && e.preventDefault();
    const timezone = moment.tz.guess();
    if (!company) {
      login({
        code,
        email: username,
        password,
        timezone,
        cb: () => setShowMfa(true),
      });
    } else {
      login({
        code,
        company,
        username,
        password,
        timezone,
        cb: () => setShowMfa(true),
      });
    }
  };

  const resend = () => {
    const timezone = moment.tz.guess();
    if (!company) {
      login({
        email: username,
        password,
        timezone,
      });
    } else {
      login({
        company,
        username,
        password,
        timezone,
      });
    }
  };

  const handleFallbackMfaSubmit = () => {
    const timezone = moment.tz.guess();
    if (!company) {
      login({
        email: username,
        password,
        timezone,
        fallbackToken,
      });
    } else {
      login({
        company,
        username,
        password,
        timezone,
        fallbackToken,
      });
    }
  };

  const showFallbackMfaForm = () => {
    setShowMfa(false);
    setShowFallbackMfa(true);
    sendEmailMfa();
  };

  const sendEmailMfa = () => {
    sendFallbackMfa({
      username,
      password,
      company,
    });
  };

  return (
    <div className="login">
      <Helmet>
        <title>{I18njs.t('helmet.Login')}</title>
      </Helmet>
      <div className="card">
        {showMfa && !!password && !!username && (
          <MfaForm
            code={code}
            setCode={setCode}
            showFallbackMfaForm={showFallbackMfaForm}
            loading={loading}
            resend={resend}
            handleSubmit={handleSubmit}
          />
        )}
        {showFallbackMfa && !showMfa && !!password && !!username && (
          <FallbackMfaForm
            fallbackToken={fallbackToken}
            setFallbackToken={setFallbackToken}
            loading={loading}
            resend={sendEmailMfa}
            handleFallbackMfaSubmit={handleFallbackMfaSubmit}
          />
        )}
        {((!showMfa && !showFallbackMfa) || !username || !password) && (
          <LoginForm
            company={company}
            error={error}
            handleSubmit={handleSubmit}
            history={history}
            loading={loading}
            password={password}
            setCompany={setCompany}
            setPassword={setPassword}
            setUsername={setUsername}
            username={username}
          />
        )}
      </div>
    </div>
  );
};

const mapStateToProps = (state) => {
  return {
    error: state.user.error,
    loading: state.user.loading,
  };
};

const mapDispatchToProps = (dispatch) => {
  const _user = bindActionCreators(UserActions, dispatch);
  return {
    login: _user.loginRequest,
    sendFallbackMfa: _user.sendFallbackMfaCodeRequest,
  };
};

export default withRouter(connect(mapStateToProps, mapDispatchToProps)(Login));
